//SaveData
interface IHashValue {
    n: string;
    v: any;
}

export class SaveDataObj {
    obj: object;
    hash: string;

    constructor() {
        this.obj = {};
        this.hash = "";
    }

    append(name: string, value: any) {
        this.obj[name] = value;
        //this.hash = this.hash + JSON.stringify({ n: name, v: value });
        const hashValues: IHashValue[] = this.hash ? JSON.parse(this.hash) : [];
        hashValues.push({ n: name, v: value });
        this.hash = JSON.stringify(hashValues);
    }

    static updateHashValue(hash: string, name: string, value: any): string {
        const hashValues: IHashValue[] = hash ? JSON.parse(hash) : [];
        let hashValue = hashValues.find(i => i.n === name);
        if (!hashValue) {
            hashValue = { n: "", v: null };
            hashValues.push(hashValue);
        }
        hashValue.v = value;
        return JSON.stringify(hashValues);
    }
}